import "GIS/Map/Control/Base";
import "UI/Util/Popup";
import "UI/Util/DOM";
import "UI/Template";
import "UI/Element";
import uuid from 'node-uuid';

/** @namespace GIS.Map.Control */
NS("GIS.Map.Control");

var hideTimer;
/**
 * @class
 * @extends GIS.Map.Control.Base
 */
GIS.Map.Control.Layers = Class(GIS.Map.Control.Base, /** @lends GIS.Map.Control.Layers.prototype */ {
    uuid: null,
    template: "GIS/Control/Layers",
    $control: null,
    $selector: null,
    hover: null,
    groups: [],
    widgets: {},
    /**
     * @inheritDoc
     */
    initialize() {
        this.ParentCall();
        this.uuid = uuid.v4();
        this.render();

        Util.each(this.groups, function (group) {
            Util.each(group.items, function (item) {
                if (item.active) this.switchLayer (item);
            }.bind(this));
        }.bind( this ));
    },

    /**
     * @returns {GIS.Map.Control.Layers}
     */
    destroy() {
        clearTimeout(hideTimer);

        if (this.hover) {
            UI.Util.Popup.destroyHover(this.hover);
            this.hover = null;
        }

        Util.each(this.widgets, widget => widget.destroy());

        this.$control.remove() && (this.$control = null);
        this.$selector.remove() && (this.$selector = null);

        return this.ParentCall();
    },
    /**
     * @returns {GIS.Map.Control.Layers}
     */
    render() {
        this.ParentCall();

        this.$control = UI.Template.$render(this.template, {
            control: this
        });
        this.$control.appendTo(this.target || this.map.element);
        this.$selector = $('[name="selector"]', this.$control);
        this.$selector.hide();

        this.$control.on("mouseenter", (args) => {
            const elements = [];

            clearTimeout(hideTimer);

            Util.each(this.widgets, (widget) => {
                const element = widget.element;

                if (element) {
                    elements.push(element);
                }
            });

            for (let i = 0; i < elements.length; i++) {
                if (UI.Util.DOM.isParent(args.target, elements[i])) {
                    return;
                }
            }

            if (!this.hover) {
                this.$selector.show();

                this.hover = UI.Util.Popup.createHover(this.$control, this.$selector);
            }
        }).on('mouseleave', () => {
            hideTimer = _.delay(() => {
                this.$selector.hide();
                this.hover = null;
            }, 1000);
        });

        UI.Element.initEvent("click", "on-click", this.$control, this);

        this.map.once("ready", () => this.refreshControls(), this);

        return this;
    },

    refreshControls() {
        Util.each(this.base, (options, name) => {
            const layer = this.map.getLayer(name);

            if (layer) {
                this.$control.find(`[base="${name}"] input[type="radio"]`, this.$control).prop("checked", layer.visible());
            }
        });

        Util.each(this.layers, (options, name) => {
            const layer = this.map.getLayer(name);

            if (layer) {
                this.$control.find(`[layer="${name}"] input[type="checkbox"]`, this.$control).prop("checked", layer.visible());
            }
        });
    },

    onItemSelect (caller) {
        let selectedItem = this.groups[$(caller).data("group")].items[$(caller).data("item")];
        this.switchLayer(selectedItem);
    },

    switchLayer (selectedItem) {
        Util.each(this.groups, (group) => {
            Util.each(group.items, (item) => {
                Util.each(item.layers, (layer) => {
                    let layerInst = this.map.getLayer(layer);
                    if (layerInst) {
                        if (selectedItem.layers.indexOf(layer)!==-1) {
                            layerInst.show();
                        } else {
                            layerInst.hide();
                        }
                    }
                });
            });
        });
    },

    onWidgetClick(caller) {
        var name;
        var options;

        if ($(caller).data("base")) {
            name = $(caller).data("base");
            options = this.base[name];
        } else {
            name = $(caller).data("layer");
            options = this.layers[name];
        }

        const layer = this.map.getLayer(name);

        if (options && options.widget && layer) {
            this.$selector.hide();

            if (this.hover) {
                UI.Util.Popup.destroyHover(this.hover);
                this.hover = null;
            }

            if (this.widgets[name]) {
                this.widgets[name].destroy();
            }

            const widget = new options.widget(null, {
                layer
            });

            widget.render().appendTo(this.$control);

            widget.on("destroy", () => delete self.widgets[name]);

            this.widgets[name] = widget;

            return false;
        }
    }
});
